module.exports={
    // 登录页
    sjhm: 'Mobile number',
    qsrdxyzm:'Pls fill in verification code',
    fsyzm:'Send verification code',
    login:'Log in',
    yIDhmmdl:'ID and password login',
    qsrID:'Pls fill in ID',
    qsrmm:'Pls fill in password',
    ysjhmdl:'Mobile number login',
    //新添加的
    zc:'注册',
    zhmm:'找回密码',
    qsrsjhm:'请输入手机号码',
    mhzxhq:'秒后重新获取',
    hqyzmsb:'获取验证码失败！',
    sbbczhmqx:'设备不存在或无权限！',
    ryzc:'人员注册',
    sfz:'身份证',
    hz:'护照',
    jzz:'居住证',
    jsz:'驾驶证',
    nbool:'男',
    ngril:'女',
    qxkmmm:'请填写开门密码！',
    qxgh:'请填写工号！',
    scgg:'上传成功',
    scsb:'上传失败',
    xlh:'序列号',
    wsh:'未审核',
    ysh:'已审核',
    rq:'日期',
    cd:'迟到',
    jb:'加班',
    zat:'早退',
    qtxbt:'请填写标题',
    qtxnr:'请填写内容',
    ysdfkgx:'已收到您的反馈，感谢您的宝贵意见！',
    fksb:'反馈失败',
    lya:'蓝牙',
    ss:'搜索',
    lykm:'蓝牙开门',
    cx:'查询',
    yc:'一次',
    lc:'俩次',
    zx:'在线',
    lx:'离线',
    kmen:'开门',
    // 首页
    yckm:'Remote open door',
    fkyy:'Visitor appointment',
    fxys:'Share E-key',
    ewmkm:'QR code open door',
    smkm:'Scan to open',
    yjkm:'One touch key',
    sy:'Home',
    zzzc:'Register',
    sb:'Device',
    wd:'Me',
    // 远程开门页面
    sbmhzwz:'Device name or location',
    cxwz:'Query location',
    sbwz:'Device location',
    zt:'Status',
    km:'Open',
    kmcg:'Open the door success',
    kmsb:'Open the door failed',
    // 访客预约页面
    xm:'Name',
    rlzp:'Face image',
    tj:'Add',
    zjlx:'ID type',
    zjh:'ID number',
    xb:'Gender',
    sfcs:'City',
    sxrs:'Entourage',
    syo:'Reasons',
    fwyxq:'Visit validity',
    bfrhm:'Interviewee number',
    bfrxm:'Interviewee name',
    tjyy:'Submit appointment',
    // 分享钥匙页面
    sssb:'Search device',
    xzsb:'Select device',
    wsb:'No device',
    fwcs:'Visit times',
    bxcs:"unlimit times",
    qjzewmdzjt:'Pls aim this QR code at the device lens and scan to open the door',
    fxewm:'Share QR code',
    // 自主注册页面
    jg:'Native place',
    hj:'Registered residence',
    qybm:'Company Dept',
    kh:'Card Number',
    kmmm:'Password',
    gh:'Work number',
    qd:'Confrim',
    qtxsjhm:'Pls fill in mobile number',
    qtxxm:'Pls fill in name',
    qxzbm:'Pls select Dept',
    qszkmmm:'Pls set door password',
    qtxgh:'Pls fill work number',
    zccg:'Registered successfully ',
    zcsb:'registered failed',
    // 我的页面
    txjl:'Access record',
    fkjl:'Visitor record',
    kqrb:'Daily Attendance',
    fkwm:'Feedback to us',
    tcdl:'Exit login',
    // 通行记录页面
    txsj:'Access time',
    kmlx:'Open door type',
    // f访客记录页面
    lfsj:'Visit time',
    shzt:'Audit status',
    mygd:'No more',
    // 反馈我们页面
    bt:'Title',
    qsrbt:'Pls fill in title',
    ly:'Leave a message ',
    qsrly:'Pls fill in message',
    tjfk:'Sumbit feedback info',
    // 退出登录页面
    sfqdtc:'Are you sure to exit?',
    qx:'Cancel',


}